export default __webpack_public_path__ + "static/media/applications-image-03.0c7c0fd4.jpg";